var _artistGalleryElementSize = 300;
var _artistGalleryOverflow = 200;
var _artistGalleryElementPadding = 15;
var _artistGalleryElementPaddingSafezone = 5;
let _galleryElementFadeTransition = 300;

var _virtualMuseumMouseX = 0;
var _virtualMuseumMouseY = 0;

var _virtualMuseumGalleryLazy = null;

var MUSEUM_LIST_TYPE_YEAR = "year";
var MUSEUM_LIST_TYPE_COUNTRY = "country";
var MUSEUM_LIST_TYPE_ART = "art";

var _currentMuseumListPage = 0;
var _currentMuseumListType = MUSEUM_LIST_TYPE_YEAR;
var _currentMuseumListValue = "";
var _currentMuseumListSearch = "";
var _blockMenuHeaderScroll = false;

var _virtualMuseumListYearCarousel = null;

var _virtualMuseumLastTouchmove = null;

var _virtualMuseumListViewMasonryEnabled = true;

let _virtualMuseumListViewMasonryColumns = {
  artists: 4,
  traces: 4,
  collaborations: 6
};

var _virtualMuseumUrl = "";

var _virtualMuseumDetailViewVisible = false;

var _virtualMuseumArtDeeplinkActive = false;
var _virtualMuseumCollaborationDeeplinkActive = false;
var _virtualMuseumListViewImageLazyLoading = null;

var _virtualMuseumListDateTagWidth = 0;

(function($) {

  Drupal.behaviors.virtualMuseum = {
    attach: function(context) {

      _virtualMuseumUrl = window.location.href;

      // helper to centralize masonry debug logs
      function masonryLog(msg) {
        try {
          if (window && window.console && window.console.log) {
            window.console.log(msg);
          }
        } catch (e) {
          // swallow errors in environments without console
        }
      }

      $(".virtualMuseumGalleryViewContainer").on('touchmove', function(e) {
        if (_blockMenuHeaderScroll) {
          e.preventDefault();
        }
      });

      Drupal.behaviors.functions.consolog("drupal init virtualMuseum");
      $(".virtualMuseum").data("original-title", document.title);
      $(".virtualMuseum", context).each(function(index) {

        Drupal.behaviors.functions.consolog("VM init()");

        $(".virtualMuseumShowGalleryButton").click(function() {
          showGalleryView();
        });

        if (!$(".virtualMuseum").hasClass("virtualMuseum--hidegallery")) {
          $(".virtualMuseumShowListButton").click(function() {
            showListView();
            showListViewArtists();
          });
        }

        if ($(window).width() < _breakpointMedium) {
          $(".virtualMuseumListViewHeaderSearch").hide();
        }
        $(".virtualMuseumListViewHeaderMobileSearch").click(function() {

          if ($(this).hasClass("active")) {
            hideMobileSearch();
          } else {
            showMobileSearch();
          }
        });

        if (!$(".virtualMuseum").hasClass("virtualMuseum--hidegallery")) {
          initGalleryView();
        }


        if (Drupal.behaviors.functions.findGetParameter("collaboration")) {
          _virtualMuseumCollaborationDeeplinkActive = true;
          initListView();
          showListView();
          showListViewCollaborations();
        } else if (Drupal.behaviors.functions.findGetParameter("art")) {
          //deeplink "art"
          $(".virtualMuseumListViewContent").empty();
          _virtualMuseumArtDeeplinkActive = true;
          _currentMuseumListValue = Drupal.behaviors.functions.findGetParameter("art");
          _currentMuseumListPage = 0;
          _currentMuseumListType = MUSEUM_LIST_TYPE_ART;
          initListView();
          showListView();
          showListViewArtists();
        } else if (Drupal.behaviors.functions.findGetParameter("year")) {
          //deeplink "year"
          $(".virtualMuseumListViewContent").empty();
          _virtualMuseumArtDeeplinkActive = true;
          _currentMuseumListValue = Drupal.behaviors.functions.findGetParameter("year");
          _currentMuseumListPage = 0;
          _currentMuseumListType = MUSEUM_LIST_TYPE_YEAR;
          initListView();
          showListView();
          showListViewArtists();
        } else {
          initListView();

          if ($(".virtualMuseum").hasClass("virtualMuseum--hidegallery")) {
            showListView();
            showListViewArtists();
          } else {
            //switch for mobile view
            if ($('.virtualMuseumGalleryView').is(':visible')) {
              showGalleryView();
              $(".virtualMuseumGalleryViewOnboarding").show();
              $(".virtualMuseumFooter").hide();
            } else if ($('.virtualMuseumListView').is(':visible')) {
              showListView();
              showListViewTraces();
            }
          }
        }


        handleResize();
        initResizeListener();

        initScrollListener();

      });

      function hideMobileSearch () {
        $(".virtualMuseumListViewHeaderMobileSearch").removeClass("active");
        $(".virtualMuseumListViewHeaderSearch").hide();
        $(".virtualMuseumListViewTags").show();
        _currentMuseumListSearch = "";
        $("#vmlvhs").val("");
      }

      function showMobileSearch () {
        $(".virtualMuseumListViewHeaderMobileSearch").addClass("active");
        $(".virtualMuseumListViewHeaderSearch").show();
        $(".virtualMuseumListViewTags").hide();
      }

      function showListView () {
        //Drupal.behaviors.functions.consolog("showListView()");
        $(".virtualMuseumGalleryViewOnboarding").hide();
        $(".virtualMuseumFooter").show();
        $(".virtualMuseumListView").show();
        $(".virtualMuseumGalleryView").hide();

        $(".virtualMuseumListView").removeClass("active");
        $(".virtualMuseumListView").addClass("active");

        $(".virtualMuseumGalleryView").removeClass("active");

        $(".virtualMuseumFooterButtons").children(".virtualMuseumFooterButton").removeClass("active");
        $(".virtualMuseumFooterButtons").children(".virtualMuseumShowListButton").addClass("active");

        $('html, body').scrollTop(0);

        handleResize();
      }

      function showGalleryView () {
        //Drupal.behaviors.functions.consolog("showGalleryView()");
        $(".virtualMuseumGalleryViewOnboarding").hide();
        $(".virtualMuseumFooter").show();
        $(".virtualMuseumListView").hide();
        $(".virtualMuseumGalleryView").show();

        $(".virtualMuseumListView").removeClass("active");

        $(".virtualMuseumGalleryView").removeClass("active");
        $(".virtualMuseumGalleryView").addClass("active");

        $(".virtualMuseumFooterButtons").children(".virtualMuseumFooterButton").removeClass("active");
        $(".virtualMuseumFooterButtons").children(".virtualMuseumShowGalleryButton").addClass("active");

        $('html, body').scrollTop(0);

        handleResize();
      }

      function initResizeListener () {
        $(window).resize(handleResize);
      }

      function getMasonryColumns(viewType) {
        var cols = _virtualMuseumListViewMasonryColumns[viewType];
        // bootstrap md breakpoint is 992px.
        if ($(window).width() < 992) {
          if (viewType === 'artists' || viewType === 'traces') {
            return 2;
          }
          if (viewType === 'collaborations') {
            return 3;
          }
        }
        return cols;
      }

      function handleResize () {

        if ($(".virtualMuseumGalleryView").hasClass("active")) {

          //set gallery view size
          $(".virtualMuseumGalleryView").css("width", $("body").innerWidth());
          $(".virtualMuseumGalleryView").css("height", $(window).innerHeight());

          //set body padding as negative margin for gallery view
          var pt = parseInt($("body").css("padding-top"));
          $(".virtualMuseumGalleryView").css("margin-top", -pt + "px");
        } else if ($(".virtualMuseumListView").hasClass("active")) {
          var h = $(window).height() - $(".saphNavHeader").height() - $(".virtualMuseumListViewHeader").height();
          $(".virtualMuseumListViewContent").css("min-height", h + "px");
          $(".virtualMuseumListViewEmptyContent").css("min-height", h + "px");

          var viewType;
          if($(".virtualMuseum").hasClass('artists')) {
              viewType = 'artists';
          } else if ($(".virtualMuseum").hasClass('traces')) {
              viewType = 'traces';
          } else if ($(".virtualMuseum").hasClass('collaborations')) {
              viewType = 'collaborations';
          }

          if (viewType) {
              var numColumns = getMasonryColumns(viewType);
              var columnWidthPercentage = (100 / numColumns) + '%';
              var calculatedColumnWidth;

              if (viewType === 'collaborations') {
                  calculatedColumnWidth = columnWidthPercentage;
              } else {
                  var gutterPixels = 10;
                  calculatedColumnWidth = `calc(${ columnWidthPercentage } - ( ( (${gutterPixels} * ${numColumns - 1}) / ${numColumns}) * 1px) )`;
              }

              $('.virtualMuseumListViewContentElementRow').each(function() {
                  var $row = $(this);
                  $row.find('.grid-sizer').css('width', calculatedColumnWidth);
                  $row.find('.virtualMuseumListViewContentElement').css('width', calculatedColumnWidth);
                  if ($row.data('masonry')) {
                      $row.masonry('layout');
                      masonryLog('masonry 1');
                  }
              });
          }
        }


        //show list view on small devices
        if ($(window).width() <= 767) {
          if ($(".virtualMuseumGalleryView").hasClass("active")) {
            //Drupal.behaviors.functions.consolog("resize handler... show list
            // view");
            showListView();
            showListViewTraces();

            if ($('.virtualMuseumOverlay').is(':visible')) {
              closeDetailView();
            }
          }
        }
      }

      function initScrollListener () {
        $(window).scroll(handleScroll);
      }

      function handleScroll () {
        var st = $(window).scrollTop();
        var ft = $("footer").offset().top - $(window).height();
        //Drupal.behaviors.functions.consolog("handleScroll() st:" + st + "
        // ft:" + ft);

        if (st > ft) {
          $(".virtualMuseumFooter").removeClass("bottom");
          $(".virtualMuseumFooter").addClass("bottom");

          //$(".virtualMuseumListViewHeader").removeClass("fixed");
          //$(".virtualMuseumListViewContent").removeClass("fixed");
        } else {
          $(".virtualMuseumFooter").removeClass("bottom");

          /*
          if(st > 0 && !$(".virtualMuseumListViewHeader").hasClass("fixed")){
              $(".virtualMuseumListViewHeader").addClass("fixed");

              $(".virtualMuseumListViewContent").removeClass("fixed");
              $(".virtualMuseumListViewContent").addClass("fixed");
          }
          else if(st == 0 && $(".virtualMuseumListViewHeader").hasClass("fixed")){
              $(".virtualMuseumListViewHeader").removeClass("fixed");
              $(".virtualMuseumListViewContent").removeClass("fixed");
          }
          */
        }

        // if (_virtualMuseumListViewMasonryEnabled && $(".virtualMuseum").hasClass("traces")) {
        //   $(".virtualMuseumListViewContentElementRow").masonry();
        // }

      }


      ///////////////////////////////
      // GALLERY VIEW

      function initGalleryView () {
        //Drupal.behaviors.functions.consolog("initGalleryView()");

        $(".preloader").show();

        $(".virtualMuseumGalleryViewContainer").empty();
        var jsonpath = $(".virtualMuseum").attr("data-url-traces-id");
        //var jsonpath = $(".virtualMuseum").attr("data-url");

        $.getJSON(jsonpath, handleGalleryViewJsonLoaded)
          .fail(function() {
              $(".preloader").hide();
              Drupal.behaviors.functions.consolog("error on load GalleryView Json");
            }
          );
      }

      function handleGalleryViewJsonLoaded (data) {

        $(".preloader").hide();

        var items = data.data;
        //console.log("load traces done! " + items.length);

        if (items.length > 0) {
          var row = 0;
          var col = 0;

          //calculate spiral positions
          var pxmin = 0;
          var pymin = 0;
          for (var p = 0; p < items.length; p++) {
            var spos = getSpiralPosition(p + 1);
            if (spos[0] < pxmin) {
              pxmin = spos[0];
            }
            if (spos[1] < pymin) {
              pymin = spos[1];
            }
          }

          //Drupal.behaviors.functions.consolog("pxmin:" + pxmin);
          //Drupal.behaviors.functions.consolog("pymin:" + pymin);

          var maxPosX = 0;
          var maxPosY = 0;

          for (var i = 0; i < items.length; i++) {
            var trace = items[i];

            var pos = getSpiralPosition(i + 1);

            var $em = $("<div></div>");
            var centerPosX = 0;
            var centerPosY = 0;
            var posX = centerPosX + (pos[0] + Math.abs(pxmin)) * _artistGalleryElementSize + _artistGalleryOverflow / 2;
            var posY = centerPosY + (pos[1] + Math.abs(pymin)) * _artistGalleryElementSize + _artistGalleryOverflow / 2;

            if (posX > maxPosX) {
              maxPosX = posX;
            }
            if (posY > maxPosY) {
              maxPosY = posY;
            }

            $em.addClass("virtualMuseumGalleryViewContainerElement");
            $em.attr("data-image", trace.img_thumbnail);
            $em.attr("data-trace-id", trace.id);
            $em.css("left", posX);
            $em.css("top", posY);
            $em.css("width", _artistGalleryElementSize + "px");
            // $em.css("height", _artistGalleryElementSize + "px");

            var ie = Drupal.behaviors.functions.detectIE();
            if (ie && ie <= 11) {
              $em.css("padding-left", _artistGalleryElementPadding + "px");
              $em.css("padding-right", _artistGalleryElementPadding + "px");
              $em.css("padding-top", _artistGalleryElementPadding + "px");
              $em.css("padding-bottom", _artistGalleryElementPadding + "px");
            } else {
              //calculate random padding
              var paddingOffsetLeft = Math.floor(Math.random() * (_artistGalleryElementPadding * 2 - _artistGalleryElementPaddingSafezone));
              var paddingLeft = _artistGalleryElementPaddingSafezone + paddingOffsetLeft;
              var paddingRight = _artistGalleryElementPadding * 2 - paddingLeft;

              var paddingOffsetTop = Math.floor(Math.random() * (_artistGalleryElementPadding * 2 - _artistGalleryElementPaddingSafezone));
              var paddingTop = _artistGalleryElementPaddingSafezone + paddingOffsetTop;
              var paddingBottom = _artistGalleryElementPadding * 2 - paddingTop;

              $em.css("padding-left", paddingLeft + "px");
              $em.css("padding-right", paddingRight + "px");
              $em.css("padding-top", paddingTop + "px");
              $em.css("padding-bottom", paddingBottom + "px");
            }

            //create image
            var $imgElement = $("<div></div>");
            $imgElement.addClass("virtualMuseumGalleryViewContainerElementImage");
            var $img = $("<img />");
            $img.attr("alt", trace.title);
            $img.attr("data-src", trace.img_thumbnail);
            $img.addClass("lazy");

            $imgElement.append($img);
            $em.append($imgElement);

            // $em.find("img").css("max-height", (_artistGalleryElementSize - (2 * _artistGalleryElementPadding)) + "px");
            $em.find("img").css("max-width", (_artistGalleryElementSize - (2 * _artistGalleryElementPadding)) + "px");

            if (i == 0) {
              $em.addClass("center");
            }


            // DEBUGGING INFO BOX ///////////
            /*
            var box = $("<div class='infobox'></div>");
            box.append("image: " + i + "<br/>");
            box.append("posX: " + posX + "<br/>");
            box.append("posY: " + posY + "<br/>");
            box.append("padding: " + paddingTop + " | " + paddingRight + " | " + paddingBottom + " | " + paddingLeft + "<br/>");
            box.append("csswidth " + $em.css("width") + "<br/>");
            box.append("cssheight " + $em.css("height") + "<br/>");
            box.append("width " + $em.width() + "<br/>");
            box.append("height " + $em.height() + "<br/>");
            box.append("imgmaxheight " + $em.find("img").css("max-height") + "<br/>");
            box.append("imgmaxwidth " + $em.find("img").css("max-width") + "<br/>");
            $em.append(box);
            */
            // DEBUGGING INFO BOX ///////////


            $em.on("mousedown", function(event) {
              //Drupal.behaviors.functions.consolog("### mousedown");
              _virtualMuseumMouseX = event.pageX;
              _virtualMuseumMouseY = event.pageY;
            });
            $em.on("mouseup", function(event) {
              //Drupal.behaviors.functions.consolog("### mouseup");
              handleElementClick(event.pageX, event.pageY, $(this).attr("data-trace-id"));
            });

            $em.on("touchstart", function(event) {
              //Drupal.behaviors.functions.consolog("### touchstart");
              _virtualMuseumLastTouchmove = null;
              _virtualMuseumMouseX = event.originalEvent.touches[0].pageX;
              _virtualMuseumMouseY = event.originalEvent.touches[0].pageY;
            });
            $em.on("touchmove", function(event) {
              //Drupal.behaviors.functions.consolog("### touchmove");
              _virtualMuseumLastTouchmove = event;
            });
            $em.on("touchend", function(event) {
              //Drupal.behaviors.functions.consolog("### touchend");
              if (_virtualMuseumLastTouchmove) {
                handleElementClick(_virtualMuseumLastTouchmove.originalEvent.touches[0].pageX, _virtualMuseumLastTouchmove.originalEvent.touches[0].pageY, $(this).attr("data-trace-id"));
              } else {
                handleElementClick(_virtualMuseumMouseX, _virtualMuseumMouseY, $(this).attr("data-trace-id"));
              }
            });

            $(".virtualMuseumGalleryViewContainer").append($em);

            //Drupal.behaviors.functions.consolog("pos:" + pos[0] + "/" +
            // pos[1] + " ### posX:" + posX + " posY:" + posY);
          }

          handleResize();

          var galleryWidth = maxPosX + _artistGalleryElementSize + _artistGalleryOverflow;
          var galleryHeight = maxPosY + _artistGalleryElementSize + _artistGalleryOverflow;
          $(".virtualMuseumGalleryViewContainer").css("width", galleryWidth);
          $(".virtualMuseumGalleryViewContainer").css("height", galleryHeight);

          // interact setup (http://interactjs.io)
          var cw = $(".virtualMuseumGalleryViewContainer").width();
          var ch = $(".virtualMuseumGalleryViewContainer").height();
          var ew = $(".virtualMuseumGalleryView").width();
          var eh = $(".virtualMuseumGalleryView").height();

          var calcTop = (ch - eh) / ch;
          var calcLeft = (cw - ew) / cw;
          var calcBottom = eh / ch;
          var calcRight = ew / cw;

          //Drupal.behaviors.functions.consolog("calcTop:" + calcTop);
          //Drupal.behaviors.functions.consolog("calcLeft:" + calcLeft);
          //Drupal.behaviors.functions.consolog("calcBottom:" + calcBottom);
          //Drupal.behaviors.functions.consolog("calcRight:" + calcRight);

          interact('.virtualMuseumGalleryViewContainer').draggable({
            inertia: true,
            restrict: {
              restriction: "parent",
              endOnly: true,
              elementRect: {
                top: (ch - eh) / ch,
                left: (cw - ew) / cw,
                bottom: eh / ch,
                right: ew / cw
              }
              //http://jsfiddle.net/mg1b03Lj/
            },
            autoScroll: true,
            onmove: dragMoveListener,
            onend: dragMoveEnd
          });

          //calculate and set initial middle position
          var halfContainerWidth = Math.round(cw / 2);
          var halfContainerHeight = Math.round(ch / 2);
          var halfViewWidth = Math.round(ew / 2);
          var halfViewHeight = Math.round(eh / 2);
          var translateX = halfViewWidth - halfContainerWidth;
          var translateY = halfViewHeight - halfContainerHeight;
          $(".virtualMuseumGalleryViewContainer").css("transform", "translate(" + translateX + "px, " + translateY + "px)")
          $(".virtualMuseumGalleryViewContainer").attr("data-x", translateX);
          $(".virtualMuseumGalleryViewContainer").attr("data-y", translateY);

          //lazy loading (http://jquery.eisbehr.de/lazy/)
          _virtualMuseumGalleryLazy = $(".virtualMuseumGalleryViewContainerElementImage").children("img.lazy").Lazy({
            appendScroll: $('.virtualMuseumGalleryViewContainer'),
            scrollDirection: 'both',
            visibleOnly: true,
            threshold: 500,
            chainable: false,
            onError: function(element) {

            },
            afterLoad: function(element) {
              var r = Math.random();
              //Drupal.behaviors.functions.consolog("VM image loaded // width:"
              // + $(element).width() + " height:" + $(element).height()) ;


              if ($(element).width() == 0 || $(element).height() == 0) {
                //no image size, no margin (safari debugging)
              } else if ($(element).width() > $(element).height()) {
                //landscape
                //var parentHeight =
                // $(element).parent(".virtualMuseumGalleryViewContainerElementImage").height();
                var parentHeight = _artistGalleryElementSize - (2 * _artistGalleryElementPadding);
                var imageHeight = $(element).height();
                var maxMT = parentHeight - imageHeight;
                var mt = Math.floor(maxMT * r);
                if (imageHeight < parentHeight / 4) {
                  //handle widescreen images
                  if (mt > parentHeight / 2) {
                    //not to the bottom
                    mt = Math.round(parentHeight / 2);
                  } else if (mt < parentHeight / 4) {
                    //not to the top
                    mt = Math.round(parentHeight / 4);
                  }
                }

                $(element).css("margin-top", mt + "px");
              } else {
                //portrait
                //var parentWidth =
                // $(element).parent(".virtualMuseumGalleryViewContainerElementImage").width();
                var parentWidth = _artistGalleryElementSize - (2 * _artistGalleryElementPadding);
                var imageWidth = $(element).width();
                var maxML = parentWidth - imageWidth;
                var ml = Math.floor(maxML * r);
                if (imageWidth < parentWidth / 4) {
                  //handle high and thin images
                  if (ml > parentWidth / 2) {
                    //not to the right
                    ml = Math.round(parentWidth / 2);
                  } else if (ml < parentWidth / 4) {
                    //not to the left
                    ml = Math.round(parentWidth / 4);
                  }
                }
                $(element).css("margin-left", ml + "px");
              }

              var ie = Drupal.behaviors.functions.detectIE();
              if (ie && ie <= 11) {
                $(element).css("margin-top", "0px");
                $(element).css("margin-left", "0px");
              }

              $(element).css("opacity", 1);
            },
            onFinishedAll: function() {

            }
          });

          handleResize();
        }

        $(".preloader").hide();
      }

      function handleElementClick (x, y, id) {

        //alert("handleElementClick()  x: " + x + " + y:" + y + " // mx:" +
        // _virtualMuseumMouseX + " my:" + _virtualMuseumMouseY);

        //check if mouse position changed (drag or click)
        if (x < _virtualMuseumMouseX + 5 && x > _virtualMuseumMouseX - 5) {
          if (y < _virtualMuseumMouseY + 5 && y > _virtualMuseumMouseY - 5) {
            //show artist gallery
            loadArtistGalleryPage(id);
          }
        }

        _virtualMuseumMouseX = 0;
        _virtualMuseumMouseY = 0;
      }

      function dragMoveEnd (event) {
        _blockMenuHeaderScroll = false;
        try {
          _virtualMuseumGalleryLazy.update();
        }
        catch (e) {
          Drupal.behaviors.functions.consolog("ERROR:" + e);
        }
      }

      function dragMoveListener (event) {

        var target = event.target;

        _blockMenuHeaderScroll = true;

        // keep the dragged position in the data-x/data-y attributes
        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
        var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

        // translate the element
        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

        // update the posiion attributes
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);

        //Drupal.behaviors.functions.consolog("dragMoveListener() y:" + y);
      }

      function getSpiralPosition (n) {
        const k = Math.ceil((Math.sqrt(n) - 1) / 2);
        var t = 2 * k + 1;
        var m = Math.pow(t, 2);

        t -= 1;

        if (n >= m - t) {
          return [k - (m - n), -k];
        }

        m -= t;

        if (n >= m - t) {
          return [-k, -k + (m - n)];
        }

        m -= t;

        if (n >= m - t) {
          return [-k + (m - n), k];
        }

        return [k, k - (m - n - t)];
      }


      ///////////////////////////////
      // LIST VIEW

      function setupCountrySelector () {
        // Drupal.behaviors.functions.consolog("virtual museum: setupCountrySelector()");

        $(".virtualMuseumListViewContent").empty();


        if (_virtualMuseumListYearCarousel) {
          _virtualMuseumListYearCarousel.flickity("destroy");
          $(".virtualMuseumListViewTags").removeClass("flickity-enabled");
          _virtualMuseumListYearCarousel = null;
        }
        $(".virtualMuseumListViewTags").empty().hide();

        $(".preloader").show();

        var jsonpath = $(".virtualMuseum").attr("data-url-artists-sort");
        if ($(".virtualMuseum").hasClass("traces")) {
          jsonpath = $(".virtualMuseum").attr("data-url-traces-sort");
        }
        // Using limit=0 to get only categories and no data items.
        jsonpath += "?page=0&type=" + MUSEUM_LIST_TYPE_COUNTRY + "&limit=0";

        $.getJSON(jsonpath, function(data) {
          $(".preloader").hide();
          var countries = data.category;
          if (countries && countries.length > 0) {
            var labelText = Drupal.t('token_select_a_country');

            var $countrySelect = $("<select class='virtualMuseumCountrySelect'></select>");
            $countrySelect.append($('<option>', {
              value: 'all',
              text: Drupal.t('token_all_countries')
            }));

            countries.sort(function(a, b) {
              if (a.display < b.display) {
                return -1;
              }
              if (a.display > b.display) {
                return 1;
              }
              return 0;
            }).forEach(function(country) {
              let access = "";
              if (country.hasOwnProperty('country')) {
                access = country.country;
              } else if (country.hasOwnProperty('public_profile_country')) {
                access = country.public_profile_country;
              }
              if (access !== null) {
                $countrySelect.append($('<option>', {
                  value: access,
                  text: access
                }));
              }
            });

            var $formField = $('<div class="formField"></div>');
            var $mainContent = $('<div class="formField-mainContent"></div>');
            var $dropField = $('<div class="formField-dropField"></div>');
            var $inputWrapper = $('<div class="formField-dropField-input position-relative"></div>');
            var $dropArrow = ('<div class="formField-dropField-Arrow singleElement position-absolute"></div>');
            var $label = $('<div class="formField-dropField-label pointer-events-none position-absolute margin-left-18"><span class="forms-inline gray">' + labelText + '</span></div>');

            $inputWrapper.append($dropArrow);
            $inputWrapper.append($countrySelect);
            $dropField.append($inputWrapper);
            $dropField.append($label);
            $mainContent.append($dropField);
            $formField.append($mainContent);

            var $fieldCol = $('<div class="col-xs-12 col-sm-6">').append($formField);
            var $fieldRow = $('<div class="row">').append($fieldCol);

            $(".virtualMuseumListViewTags").append($fieldRow).show();

            Drupal.behaviors.formFields.attach($('.virtualMuseumListViewTags'));

            // Set initial value and load data when country tab is selected
            _currentMuseumListValue = "all";
            loadListViewJson(false);

            $countrySelect.change(function() {
              var selectedCountry = $(this).val();
              $(".virtualMuseumListViewContent").empty();
              _currentMuseumListPage = 0;
              _currentMuseumListSearch = "";
              $("#vmlvhs").val("");

              if (selectedCountry) {
                _currentMuseumListValue = selectedCountry;
                loadListViewJson(false);
              } else {
                _currentMuseumListValue = "";
                // Do nothing, user selected placeholder
              }
            });
          }
        }).fail(function() {
          $(".preloader").hide();
          Drupal.behaviors.functions.consolog("error on load country list for selector");
        });
      }

      function initListView () {

        //Drupal.behaviors.functions.consolog("initListView()");

        if ($(".virtualMuseumListViewHeaderSwitchButton.active").length > 0) {
          if ($("#virtualMuseumListViewHeaderSwitchButtonArtists").hasClass("active")) {
            showListViewArtists();
          } else if ($("#virtualMuseumListViewHeaderSwitchButtonArtists").hasClass("active")) {
            showListViewTraces();
          } else if ($("#virtualMuseumListViewHeaderSwitchButtonCollaborations").hasClass("active")) {
            showListViewCollaborations();
          }
        }

        //radio buttons
        $("#vmlvhrb_" + _currentMuseumListType).prop("checked", true); //radio
                                                                       // button
                                                                       // "name"
                                                                       // preselected
        $(".virtualMuseumListViewHeaderRadioButton").unbind().click(function() {

          if ($(this).children("input").prop("checked")) {
            //Drupal.behaviors.functions.consolog("CLICKED RADIO " +
            // $(this).children("input").val() + " # do nothing!");
          } else {
            $(this).children("input").prop("checked", true);
            //Drupal.behaviors.functions.consolog("CLICKED RADIO " +
            // $(this).children("input").val() + " # " +
            // $(this).children("input").prop("checked"));

            if ($(window).width() < _breakpointMedium) {
              hideMobileSearch();
            }

            $(".virtualMuseumListViewContent").empty();
            _currentMuseumListValue = "";
            _currentMuseumListPage = 0;
            _currentMuseumListType = $(this).children("input").val();
            _currentMuseumListSearch = "";
            $("#vmlvhs").val("");

            if (_currentMuseumListType == MUSEUM_LIST_TYPE_COUNTRY) {
              setupCountrySelector();
            } else {
              loadListViewJson(false);
            }
          }
        });

        //search field
        $(".virtualMuseumListViewHeaderSearch").children(".iconSaph").click(function() {
          handleListViewSearchButton();
        });
        $(".virtualMuseumListViewHeaderSearch").find("input").on("keyup", function(e) {
          if (e.keyCode == 13) {
            e.preventDefault();
            handleListViewSearchButton();
          } else if (e.keyCode == 46 || e.keyCode == 8) {
            if ($(".virtualMuseumListViewHeaderSearch").find("input").val() == "") {
              handleListViewSearchButton();
            }
          }
        });

        $("#virtualMuseumListViewHeaderSwitchButtonArtists").click(function() {
          if ($(this).hasClass("active")) {
            if (_currentMuseumListType == MUSEUM_LIST_TYPE_YEAR || _currentMuseumListType == MUSEUM_LIST_TYPE_COUNTRY) {
              $(".virtualMuseum").removeClass("artists");
              $(".virtualMuseumListViewTag--date").removeClass("active");
              _currentMuseumListPage = 0;
              if (_currentMuseumListType == MUSEUM_LIST_TYPE_COUNTRY) {
                $('.virtualMuseumCountrySelect').val('');
              }
              _currentMuseumListValue = "";
              _currentMuseumListSearch = "";
              $("#vmlvhs").val("");
              showListViewArtists();
            }
          } else {
            showListViewArtists();
          }
        });
        $("#virtualMuseumListViewHeaderSwitchButtonTraces").click(function() {
          if ($(this).hasClass("active")) {
            if (_currentMuseumListType == MUSEUM_LIST_TYPE_YEAR || _currentMuseumListType == MUSEUM_LIST_TYPE_COUNTRY) {
              $(".virtualMuseum").removeClass("traces");
              $(".virtualMuseumListViewTag--date").removeClass("active");
              _currentMuseumListPage = 0;
              if (_currentMuseumListType == MUSEUM_LIST_TYPE_COUNTRY) {
                $('.virtualMuseumCountrySelect').val('');
              }
              _currentMuseumListValue = "";
              _currentMuseumListSearch = "";
              $("#vmlvhs").val("");
              showListViewTraces();
            }
          } else {
            showListViewTraces();
          }
        });
        $("#virtualMuseumListViewHeaderSwitchButtonCollaborations").click(function() {
          if ($(this).hasClass("active")) {

          } else {
            if (_virtualMuseumListYearCarousel) {
              _virtualMuseumListYearCarousel.flickity("destroy");
              $(".virtualMuseumListViewTags").removeClass("flickity-enabled");
              _virtualMuseumListYearCarousel = null;
            }
            _virtualMuseumListYearCarousel = false;
            $(".virtualMuseumListViewTags").empty();
            showListViewCollaborations();
          }
        });
      }

      function handleListViewSearchButton () {
        var string = $(".virtualMuseumListViewHeaderInput").children("input").val();
        //Drupal.behaviors.functions.consolog("SEARCH: " + string);
        _currentMuseumListSearch = "";
        if (string && string != "") {
          $(".virtualMuseumListViewContent").empty();
          _currentMuseumListPage = 0;
          _currentMuseumListSearch = string;
          loadListViewJson(false);
        } else {
          $(".virtualMuseumListViewContent").empty();
          _currentMuseumListPage = 0;
          _currentMuseumListSearch = "";
          loadListViewJson(false);
        }

        if ($(".virtualMuseumListViewTag").length > 0) {
          $(".virtualMuseumListViewTag").removeClass("active");
        }
      }

      function showListViewArtists () {
        Drupal.behaviors.functions.consolog("virtual museum: showListViewArtists() ");
        $(".preloader").show();
        $(".virtualMuseumListViewHeaderSwitchButton").removeClass("active");
        $(".virtualMuseumListViewHeaderSwitchButton").show();
        $(".virtualMuseumListViewHeaderRadioButtons").show();
        $(".virtualMuseumBackLink").hide();
        $(".virtualMuseumListViewTags").hide();
        $(".virtualMuseumListViewText").hide();
        $("#virtualMuseumListViewHeaderSwitchButtonArtists").addClass("active");

        if ($(window).width() < _breakpointMedium) {
          $(".virtualMuseumListViewHeaderSearch").hide();
          $(".virtualMuseumListViewHeaderMobileSearch").show();
        } else {
          $(".virtualMuseumListViewHeaderSearch").show();
        }

        if ($(".virtualMuseum").hasClass("artists")) {
          //show list view
          $(".preloader").hide();
        } else {
          $(".virtualMuseum").removeClass("artists");
          $(".virtualMuseum").removeClass("traces");
          $(".virtualMuseum").removeClass("collaborations");
          $(".virtualMuseum").addClass("artists");

          $(".virtualMuseumListViewContent").empty();
          $(".virtualMuseumListViewHeaderInput").children("input").val("");
          _currentMuseumListSearch = "";
          _currentMuseumListPage = 0;
          loadListViewJson(false);
        }
      }

      function showListViewTraces () {
        Drupal.behaviors.functions.consolog("virtual museum: showListViewTraces() ");
        $(".preloader").show();
        $(".virtualMuseumListViewHeaderSwitchButton").removeClass("active");
        $(".virtualMuseumListViewHeaderSwitchButton").show();
        $(".virtualMuseumListViewHeaderRadioButtons").show();
        $(".virtualMuseumBackLink").hide();
        $(".virtualMuseumListViewTags").hide();
        $(".virtualMuseumListViewText").hide();
        $("#virtualMuseumListViewHeaderSwitchButtonTraces").addClass("active");

        if ($(window).width() < _breakpointMedium) {
          $(".virtualMuseumListViewHeaderSearch").hide();
          $(".virtualMuseumListViewHeaderMobileSearch").show();
        } else {
          $(".virtualMuseumListViewHeaderSearch").show();
        }

        if ($(".virtualMuseum").hasClass("traces")) {
          //show list view
          $(".preloader").hide();
        } else {
          $(".virtualMuseum").removeClass("artists");
          $(".virtualMuseum").removeClass("traces");
          $(".virtualMuseum").removeClass("collaborations");
          $(".virtualMuseum").addClass("traces");

          $(".virtualMuseumListViewContent").empty();
          $(".virtualMuseumListViewHeaderInput").children("input").val("");
          _currentMuseumListSearch = "";
          _currentMuseumListPage = 0;
          loadListViewJson(false);
        }
      }

      function showListViewCollaborations () {
        Drupal.behaviors.functions.consolog("virtual museum: showListViewCollaborations() ");
        $(".preloader").show();
        $(".virtualMuseumListViewHeaderSwitchButton").removeClass("active");
        $(".virtualMuseumListViewHeaderRadioButtons").hide();
        $(".virtualMuseumListViewHeaderSearch").hide();
        $(".virtualMuseumListViewHeaderMobileSearch").hide();
        $(".virtualMuseumListViewHeaderMobileSearch").removeClass("active");
        $(".virtualMuseumBackLink").show();
        $(".virtualMuseumListViewTags").show();
        $(".virtualMuseumListViewText").hide();
        $("#virtualMuseumListViewHeaderSwitchButtonCollaborations").addClass("active");

        if ($(".virtualMuseum").hasClass("collaborations")) {
          //show list view
          $(".preloader").hide();
        } else {
          $(".virtualMuseum").removeClass("artists");
          $(".virtualMuseum").removeClass("traces");
          $(".virtualMuseum").removeClass("collaborations");
          $(".virtualMuseum").addClass("collaborations");

          $(".virtualMuseumListViewContent").empty();
          $(".virtualMuseumListViewHeaderInput").children("input").val("");
          _currentMuseumListSearch = "";
          _currentMuseumListPage = 0;

          loadListViewJson(false);
        }
      }

      function handleCollaborationTagClick () {

        $(".virtualMuseumListViewTextBlock").hide();

        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(".virtualMuseumListViewCollaborationElement").show();
          $(".virtualMuseumListViewText").hide();
        } else {
          $(".virtualMuseumListViewTag").removeClass("active");
          $(this).addClass("active");

          var cId = $(this).attr("data-id");

          $(".virtualMuseumListViewText").children("[data-tag='" + $(this).html() + "']").show();
          $(".virtualMuseumListViewText").show();

          $(".virtualMuseumListViewCollaborationElement").each(function() {
            if ($(this).attr("data-collaboration-id") == cId) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });

          if (_virtualMuseumListViewMasonryEnabled) {
            $(".virtualMuseumListViewContentElementRow").masonry('layout');
            masonryLog('masonry 2');
          }
        }
      }

      function handleFormOfArtTagClick () {
        //empty searchfield
        $("#vmlvhs").val("");
        _currentMuseumListSearch = "";

        //reset page value
        _currentMuseumListPage = 0;

        //set form of art value
        _currentMuseumListValue = $(this).attr("data-id");
        $(".virtualMuseumListViewContent").empty();
        loadListViewJson(false);
      }

      function handleYearTagClick () {

        //empty searchfield
        $("#vmlvhs").val("");
        _currentMuseumListSearch = "";

        //reset page value
        _currentMuseumListPage = 0;

        //set year value
        _currentMuseumListValue = $(this).attr("data-id");
        $(".virtualMuseumListViewContent").empty();
        loadListViewJson(false);

        $(".virtualMuseumListViewTag").removeClass("active");
        $(this).addClass("active");

        if (_virtualMuseumListYearCarousel) {
          _virtualMuseumListYearCarousel.flickity('select', $(this).attr("data-flickity-id"));
        }

      }

      function loadListViewJson (handleLazyLoading) {

        Drupal.behaviors.functions.consolog("virtual museum: loadListViewJson()  // handleLazyLoading:" + handleLazyLoading);

        //artists
        var jsonpath = $(".virtualMuseum").attr("data-url-artists-sort");

        //traces
        if ($(".virtualMuseum").hasClass("traces")) {
          jsonpath = $(".virtualMuseum").attr("data-url-traces-sort");
        }

        jsonpath += "?page=" + _currentMuseumListPage;
        jsonpath += "&type=" + _currentMuseumListType;
        jsonpath += "&limit=20";

        //collaborations
        if ($(".virtualMuseum").hasClass("collaborations")) {
          jsonpath = $(".virtualMuseum").attr("data-url-collaborations-sort") + "?limit=1000";

          if ($(".virtualMuseumListViewCollaborationElement").length > 0) {
            //no further loading on collaborations
            return;
          }
        }

        //show loader
        if (!handleLazyLoading) {
          $(".preloader").show();
        }

        if (_currentMuseumListSearch != "") {
          jsonpath += "&search=" + _currentMuseumListSearch;
        } else if (_currentMuseumListValue != "") {
          jsonpath += "&value=" + _currentMuseumListValue;
        }

        Drupal.behaviors.functions.consolog("virtual museum: loadListViewJson(false) " + jsonpath);

        $.getJSON(jsonpath, handleListViewJsonLoaded)
          .fail(function() {
              $(".preloader").hide();
              Drupal.behaviors.functions.consolog("error on load ListView Json");
            }
          );
      }

      function handleListViewJsonLoaded (data) {

        Drupal.behaviors.functions.consolog("handleListViewJsonLoaded() data:" + data);

        var jsonData = data.data;
        var jsonCategory = data.category;
        var virtualMGrid;

        $(".virtualMuseumListViewTags").removeClass("virtualMuseumListViewTags--date");

        var count = 0;

        if ($(".virtualMuseum").hasClass("collaborations")) {

          var $block = null;
          var $elementRow = null;
          if ($(".virtualMuseumListViewContent").find(".virtualMuseumListViewContentElementRow").length == 0) {
            $block = $("<div class='virtualMuseumListViewContentBlock' data-category=''></div>");
            $elementRow = $("<div class='virtualMuseumListViewContentElementRow'></div>");
            $block.append($elementRow);
            $(".virtualMuseumListViewContent").html($block);
          } else {
            $elementRow = $(".virtualMuseumListViewContent").find(".virtualMuseumListViewContentElementRow");
          }

          //hide element row if deeplink is active
          if (_virtualMuseumCollaborationDeeplinkActive) {
            $(".virtualMuseumListViewContentElementRow").css("opacity", 0);
          }

          var numColumns = _virtualMuseumListViewMasonryColumns.collaborations;
          var columnWidthPercentage = (100 / numColumns) + '%';

          //masonry setup
          if (_virtualMuseumListViewMasonryEnabled) {
            $elementRow.append($('<div class="grid-sizer"></div>').css('width', columnWidthPercentage));

            virtualMGrid = $elementRow.masonry({
              initLayout: false,
              columnWidth: '.grid-sizer',
              itemSelector: '.virtualMuseumListViewContentElement',
              percentPosition: true,
              horizontalOrder: true
            });
            masonryLog('masonry 3');
            virtualMGrid.masonry();
            masonryLog('masonry 4');
          }

          $(".virtualMuseumListViewTags").empty();

          for (var k = 0; k < jsonData.length; k++) {

            var collab = jsonData[k];

            var $tagElement = $("<div class='virtualMuseumListViewTag' data-id='" + collab.id + "'>#" + collab.title + "</div>");
            $tagElement.unbind().click(handleCollaborationTagClick);
            $(".virtualMuseumListViewTags").append($tagElement);

            for (var l = 0; l < collab.images.length; l++) {

              var item = collab.images[l];
              count++;

              var $listElement = $("<div class='virtualMuseumListViewContentElement virtualMuseumListViewCollaborationElement' title='" + item.description + "'></div>");
              $listElement.css('width', columnWidthPercentage);
              $listElement.attr("data-collaboration-id", collab.id);
              $listElement.attr("data-profile-id", item.public_profile_id);
              $listElement.attr("data-artist-id", item.artist_id);

              var $img = $("<img />");
              $listElement.attr("data-image", item.img_thumbnail);
              $img.attr("data-src", item.img_thumbnail);

              $img.attr("alt", item.alt);
              $img.attr("src", item.img_thumbnail);

              $listElement.append($img);
              $listElement.addClass("visible");

              $listElement.append("<p>" + item.description + "</p>");

              $listElement.click(function() {
                $(this).addClass("active");
                loadArtistProfilePage($(this).attr("data-artist-id"));
                //loadArtistGalleryPage($(this).attr("data-trace-id"));
              });
              $listElement.hover(
                function () {
                  $(this).addClass('virtualMuseumListViewContentElement--hover');
                },
                function () {
                  $(this).removeClass('virtualMuseumListViewContentElement--hover');
                }
              );
              //append new element to page
              // if($('[data-artist-id="'+ item.artist_id + '"]',
              // $elementRow).length < 1){
              $elementRow.append($listElement);

              //append new element to masonry
              if (_virtualMuseumListViewMasonryEnabled) {
                $elementRow.masonry('appended', $listElement);
                masonryLog('masonry 5');
              }
              // }
            }
          }

          if (_virtualMuseumListViewMasonryEnabled) {
            $(".virtualMuseumListViewContentElementRow").masonry('layout');
            masonryLog('masonry 6');
            setTimeout(function() {
              if (_virtualMuseumListViewMasonryEnabled) {
                $(".virtualMuseumListViewContentElementRow").masonry('layout');
                masonryLog('masonry 7');
              }
            }, 250);
            setTimeout(function() {
              if (_virtualMuseumListViewMasonryEnabled) {
                $(".virtualMuseumListViewContentElementRow").masonry('layout');
                masonryLog('masonry 8');
              }
            }, 1000);
            setTimeout(function() {
              if (_virtualMuseumListViewMasonryEnabled) {
                $(".virtualMuseumListViewContentElementRow").masonry('layout');
                masonryLog('masonry 9');
              }
            }, 2500);
          }

          if (_virtualMuseumCollaborationDeeplinkActive) {
            setTimeout(function() {
              $(".virtualMuseumListViewTag").each(function() {
                if ($(this).attr("data-id") == Drupal.behaviors.functions.findGetParameter("collaboration")) {
                  $(this).trigger("click");
                }
              });
              $(".virtualMuseumListViewContentElementRow").css("opacity", 1);
              _virtualMuseumCollaborationDeeplinkActive = false;
            }, 500);
          }
        } else {

          if (_currentMuseumListType == MUSEUM_LIST_TYPE_YEAR) {

            $(".virtualMuseumListViewTags").addClass("virtualMuseumListViewTags--date");

            if ($(".virtualMuseumListViewTag--date").length == 0) {

              $(".virtualMuseumListViewTags").hide();

              $(".virtualMuseumListViewTags").empty();

              //create timeline tags (2 times because of endless scrolling)
              var fid = 0;
              for (var k = 0; k < jsonCategory.length; k++) {
                if (jsonCategory[k].year) {
                  var $yearTagElement = $("<div class='virtualMuseumListViewTag virtualMuseumListViewTag--date' data-id='" + jsonCategory[k].year + "'>" + jsonCategory[k].year + "</div>");
                  $yearTagElement.unbind().click(handleYearTagClick);
                  $yearTagElement.attr("data-flickity-id", fid);
                  fid++;
                  $(".virtualMuseumListViewTags").append($yearTagElement);
                }
              }
              for (var k2 = 0; k2 < jsonCategory.length; k2++) {
                if (jsonCategory[k2].year) {
                  var $yearTagElement = $("<div class='virtualMuseumListViewTag virtualMuseumListViewTag--date' data-id='" + jsonCategory[k2].year + "'>" + jsonCategory[k2].year + "</div>");
                  $yearTagElement.unbind().click(handleYearTagClick);
                  $yearTagElement.attr("data-flickity-id", fid);
                  fid++;
                  $(".virtualMuseumListViewTags").append($yearTagElement);
                }
              }

              //show tag list if search is empty
              $(".virtualMuseumListViewTags").show();

              //calculate full tag list width
              _virtualMuseumListDateTagWidth = 0;
              $(".virtualMuseumListViewTag--date").each(function() {
                _virtualMuseumListDateTagWidth += $(this).outerWidth();
              });

              //init carousel on smaller screens
              if (true || _virtualMuseumListDateTagWidth > $(window).width()) {

                if (!_virtualMuseumListYearCarousel) {
                  //carousel (https://flickity.metafizzy.co/api.html)
                  _virtualMuseumListYearCarousel = $(".virtualMuseumListViewTags").flickity({
                    pageDots: false,
                    prevNextButtons: false,
                    cellAlign: 'center',
                    freeScroll: true,
                    wrapAround: true,
                    initialIndex: Math.round(jsonCategory.length / 2)
                  });
                  _virtualMuseumListYearCarousel.flickity('resize');
                }
              }

              /*
              console.log("handleListViewJsonLoaded() => MUSEUM_LIST_TYPE_YEAR");
              console.log("_virtualMuseumListYearCarousel:" + _virtualMuseumListYearCarousel);
              console.log("_virtualMuseumListDateTagWidth:" + _virtualMuseumListDateTagWidth);
              console.log("$(window).width():" + $(window).width());
              */
            }

            if (_currentMuseumListSearch != "") {
              //hide tag list if search is not empty
              $(".virtualMuseumListViewTags").hide();
            } else {
              $(".virtualMuseumListViewTags").show();
            }


            if (_virtualMuseumArtDeeplinkActive) {
              $(".virtualMuseumListViewTag--date").each(function() {
                if ($(this).attr("data-id") == _currentMuseumListValue && !$(this).hasClass("active")) {
                  $(this).addClass("active");

                  if (_virtualMuseumListYearCarousel) {
                    _virtualMuseumListYearCarousel.flickity('select', $(this).attr("data-flickity-id"));
                  }
                }
              });

              _virtualMuseumArtDeeplinkActive = false;
            }
          } else if (_currentMuseumListType == MUSEUM_LIST_TYPE_COUNTRY) {
            if (_virtualMuseumListYearCarousel) {
              _virtualMuseumListYearCarousel.flickity("destroy");
              $(".virtualMuseumListViewTags").removeClass("flickity-enabled");
              _virtualMuseumListYearCarousel = null;
            }

            // Only hide/empty tags if the country selector dropdown does not exist,
            // otherwise, the dropdown would be removed and selection lost.
            if ($('.virtualMuseumCountrySelect').length === 0) {
              //no tags for country
              $(".virtualMuseumListViewTags").hide();
              $(".virtualMuseumListViewTags").empty();
            } else {
              $(".virtualMuseumListViewTags").show();
            }

          } else if (_currentMuseumListType == MUSEUM_LIST_TYPE_ART) {

            if (_virtualMuseumListYearCarousel) {
              _virtualMuseumListYearCarousel.flickity("destroy");
              $(".virtualMuseumListViewTags").removeClass("flickity-enabled");
              _virtualMuseumListYearCarousel = null;
            }

            $(".virtualMuseumListViewTags").hide();
            $(".virtualMuseumListViewTags").empty();

            /*
            if(_virtualMuseumArtDeeplinkActive){
              _currentMuseumListValue = Drupal.behaviors.functions.findGetParameter("art");
              _virtualMuseumArtDeeplinkActive = false;
            }
            */

            if (_currentMuseumListSearch == "") {
              //create and show tag list if search is empty
              for (var l = 0; l < jsonCategory.length; l++) {
                if (jsonCategory[l].value) {
                  var $artTagElement = $("<div class='virtualMuseumListViewTag virtualMuseumListViewTag--form-of-art' data-id='" + jsonCategory[l].value + "'>" + jsonCategory[l].display + "</div>");
                  if (_currentMuseumListValue == jsonCategory[l].value) {
                    $artTagElement.addClass("active");
                  }
                  $artTagElement.unbind().click(handleFormOfArtTagClick);
                  $(".virtualMuseumListViewTags").append($artTagElement);
                }
              }
              $(".virtualMuseumListViewTags").show();
            }
          }

          var viewType = $(".virtualMuseum").hasClass('artists') ? 'artists' : 'traces';
          var numColumns = _virtualMuseumListViewMasonryColumns[viewType];
          var columnWidthPercentage = (100 / numColumns) + '%';
          let gutterPixels = 10;
          let calculatedColumnWidth = `calc(${ columnWidthPercentage } - ( ( (${gutterPixels} * ${numColumns - 1}) / ${numColumns}) * 1px) )`;

          for (var i = 0; i < jsonData.length; i++) {
            var blockData = jsonData[i];
            var $block = null;
            var $elementRow = null;

            if ($(".virtualMuseumListViewContentBlock[data-category='" + escape(blockData.category) + "']").length > 0) {
              Drupal.behaviors.functions.consolog("handleListViewJsonLoaded() found block " + blockData.category + " ");

              //existing block
              $block = $(".virtualMuseumListViewContentBlock[data-category='" + escape(blockData.category) + "']");

              //existing element row
              $elementRow = $block.find(".virtualMuseumListViewContentElementRow");
            } else {
              Drupal.behaviors.functions.consolog("handleListViewJsonLoaded() create block " + blockData.category + " ");
              $block = $("<div class='virtualMuseumListViewContentBlock' data-category='" + escape(blockData.category) + "'></div>");
              $(".virtualMuseumListViewContent").append($block);

              //row title
              var $titleRow = $("<div class='row'></div>");
              var $titleElement = $("<div class='col-sm-12 virtualMuseumListViewContentTitle'></div>");
              $titleElement.append("<p>" + blockData.category + "</p>");
              $titleRow.append($titleElement);
              $block.append($titleRow);

              //new elements row
              $elementRow = $("<div class='row virtualMuseumListViewContentElementRow'></div>");
            }

            //masonry setup
            if (_virtualMuseumListViewMasonryEnabled) {
              if ($elementRow.find('.grid-sizer').length === 0) {
                $elementRow.append($('<div class="grid-sizer"></div>').css('width', calculatedColumnWidth ));
                virtualMGrid = $elementRow.masonry({
                  initLayout: false,
                  columnWidth: '.grid-sizer',
                  itemSelector: '.virtualMuseumListViewContentElement',
                  percentPosition: true,
                  gutter: gutterPixels,
                  horizontalOrder: true
                });
                masonryLog('masonry 10');
                virtualMGrid.masonry();
                masonryLog('masonry 11');
              }
            }


            //elements
            if (blockData.traces) {
              for (var j = 0; j < blockData.traces.length; j++) {

                var item = blockData.traces[j];

                let artist_id_temp = item?.artist_id ?? item?.id;

                if ($('[data-artist-id="' + artist_id_temp + '"]', $elementRow).length < 1) {

                  count++;

                  var $listElement = $("<div class='virtualMuseumListViewContentElement' title='" + item.title + "'></div>");

                  $listElement.css('width', calculatedColumnWidth);

                  if ($(".virtualMuseum").hasClass("artists")) {
                    $listElement.attr("data-artist-id", item.id);
                  } else {
                    $listElement.attr("data-trace-id", item.id);
                    $listElement.attr("data-artist-id", item.artist_id);
                  }

                  if (($(".virtualMuseum").hasClass("traces") && item.img_thumbnail && item.img_thumbnail != "") ||
                    ($(".virtualMuseum").hasClass("artists") && item.img_high_res_alt && item.img_high_res_alt != "")) {

                    let $imgWrapper = $("<div class='virtualMuseumListViewContentElement__imageWrapper'></div>");

                    if ($(".virtualMuseum").hasClass("traces")) {
                      var $img = $("<img />");
                      $listElement.attr("data-image", item.img_thumbnail);
                      $img.attr("data-src", item.img_thumbnail);
                      $listElement.attr("data-artist-image", item.img_artist_profile_high_res);
                      $img.attr("alt", item.title);
                      $img.attr("src", "");
                      $img.addClass("lazy");
                      $imgWrapper.append($img);
                    } else {
                      $listElement.attr("data-image", item.img_high_res_alt);
                      $listElement.attr("data-trace-image", item.trace_image_url);

                      var $img1 = $("<img />");
                      $img1.attr('data-src', item.img_high_res_alt);
                      $img1.attr('alt', item.title);
                      $img1.attr('src', '');
                      $img1.addClass('lazy artist-img-primary');



                      if (item.trace_image_url) {
                        var $img2 = $("<img />");
                        $img2.attr('data-src', item.trace_image_url);
                        $img2.attr('alt', item.title);
                        $img2.attr('src', '');
                        $img2.css('opacity', '0');
                        $img2.addClass('lazy artist-img-hover');
                        $imgWrapper.append($img2);
                      }
                      $imgWrapper.append($img1);
                    }

                    $listElement.addClass("not-lazy-loaded");
                    $listElement.append($imgWrapper);

                  }

                  if (count < 16) {
                    $listElement.addClass("visible");
                  }

                  $listElement.append("<p>" + item.title + "</p>");

                  $listElement.click(function() {
                    $(this).addClass("active");
                    loadArtistProfilePage($(this).attr("data-artist-id"));
                    //loadArtistGalleryPage($(this).attr("data-trace-id"));
                  });

                  if ($(".virtualMuseum").hasClass("artists")) {
                    $listElement.hover(
                      function() { // mouseenter
                        var $img1 = $(this).find('.artist-img-primary');
                        var $img2 = $(this).find('.artist-img-hover');
                        if ($img2.length) {
                          $img1.css('opacity', 0);
                          $img2.css('opacity', 1);
                        }
                      },
                      function() { // mouseleave
                        var $img1 = $(this).find('.artist-img-primary');
                        var $img2 = $(this).find('.artist-img-hover');
                        if ($img2.length) {
                          $img2.css('opacity', 0);
                          $img1.css('opacity', 1);
                        }
                      }
                    );
                  }


                  //append new element to page
                  $elementRow.append($listElement);

                  //append new element to masonry
                  if (_virtualMuseumListViewMasonryEnabled) {
                    $elementRow.masonry('appended', $listElement);
                    masonryLog('masonry 12');
                  }
                }
              }
            }

            $block.append($elementRow);
          }

          if (_currentMuseumListValue != "") {
            // $(".virtualMuseumListViewContentTitle").css("opacity", 0);
          } else {
            $(".virtualMuseumListViewContentTitle").css("opacity", 1);
          }

          // Explicit masonry layout calls for traces/artists views after elements are added
          if (_virtualMuseumListViewMasonryEnabled) {
            $(".virtualMuseumListViewContentElementRow").masonry('layout');
            masonryLog('masonry 20');
            setTimeout(function() {
              if (_virtualMuseumListViewMasonryEnabled) {
                $(".virtualMuseumListViewContentElementRow").masonry('layout');
                masonryLog('masonry 20a');
              }
            }, 250);
            setTimeout(function() {
              if (_virtualMuseumListViewMasonryEnabled) {
                $(".virtualMuseumListViewContentElementRow").masonry('layout');
                masonryLog('masonry 20b');
              }
            }, 1000);
          }
        }

        activateListViewImageLazyLoading();


        if (jsonData.length == 0) {

          //no search results on first page?!
          if (_currentMuseumListPage == 0) {
            var noresultHtml = "";
            noresultHtml += "<div class='virtualMuseumListViewEmptyContent'>";
            noresultHtml += "<div class='virtualMuseumListViewEmptyContentCell'>";
            noresultHtml += "<h1>No result</h1>";
            noresultHtml += "<p>Try another keyword or category</p>";
            noresultHtml += "</div>";
            noresultHtml += "</div>";

            $(".virtualMuseumListViewContent").html(noresultHtml);

            handleResize();
          }
        }

        $(".preloader").hide();

      }

      function destroyListViewImageLazyLoading () {
        if (_virtualMuseumListViewImageLazyLoading) {
          _virtualMuseumListViewImageLazyLoading.destroy();
        }
      }

      function activateListViewImageLazyLoading () {

        if ($(".virtualMuseumListView").hasClass("active")) {

          //lazy loading (http://jquery.eisbehr.de/lazy/)
          _virtualMuseumListViewImageLazyLoading = $(".virtualMuseumListViewContentElement.not-lazy-loaded").find("img.lazy").Lazy({
            scrollDirection: 'vertical',
            chainable: false,
            threshold: 1000,
            onError: function(element) {

            },
            afterLoad: function(element) {
              var $img = $(element);
              var imageHeight = $img.height();
              var $parentListElement = $img.closest(".virtualMuseumListViewContentElement");
              var $imgWrapperElement = $img.closest(".virtualMuseumListViewContentElement__imageWrapper");

              if ($img.hasClass('artist-img-primary')) {
                setTimeout(function(){
                  var currentImgHeight = $img.height();
                  if (currentImgHeight > 0) {
                    $imgWrapperElement.css("height", currentImgHeight + "px");
                  }
                }, 250);

              }

              //Drupal.behaviors.functions.consolog("lazy loaded img:" +
              // $(element).parent(".virtualMuseumListViewContentElement").attr("data-image"));
              $parentListElement.removeClass("not-lazy-loaded");

              if ($(".virtualMuseum").hasClass("traces") || $(".virtualMuseum").hasClass("collaborations") || $(".virtualMuseum").hasClass("artists")) {

                if (_virtualMuseumListViewMasonryEnabled && !_virtualMuseumDetailViewVisible) {
                  //reload masonry layout for images
                  $parentListElement.closest(".virtualMuseumListViewContentElementRow").masonry();
                  masonryLog('masonry 13');
                  Drupal.behaviors.functions.consolog("Calling Masonry after loading Image" + element.attr("src"));

                  //call masonry again and again for safari....
                  setTimeout(function($row) {
                    $row.masonry();
                    masonryLog('masonry 14');
                  }, 500, $(element).closest(".virtualMuseumListViewContentElementRow"));
                  setTimeout(function($row) {
                    $row.masonry();
                    masonryLog('masonry 15');
                  }, 1000, $(element).closest(".virtualMuseumListViewContentElementRow"));
                  setTimeout(function($row) {
                    $row.masonry();
                    masonryLog('masonry 16');
                  }, 2500, $(element).closest(".virtualMuseumListViewContentElementRow"));
                  setTimeout(function($row) {
                    $row.masonry();
                    masonryLog('masonry 17');
                  }, 5000, $(element).closest(".virtualMuseumListViewContentElementRow"));
                  setTimeout(function($row) {
                    $row.masonry();
                    masonryLog('masonry 18');
                  }, 10000, $(element).closest(".virtualMuseumListViewContentElementRow"));
                }
              }
            },
            onFinishedAll: function() {

              Drupal.behaviors.functions.consolog("lazy loaded all! element:" + $(this));

              if (!_virtualMuseumDetailViewVisible) {
                _currentMuseumListPage++;
                Drupal.behaviors.functions.consolog("lazy loaded all... loadListViewJson(false)");
                loadListViewJson(true);
              }
            }
          });
        }
      }

      function loadArtistGalleryPage (traceid, userid) {

        if (!traceid) {
          return;
        }

        //Drupal.behaviors.functions.consolog("show artist gallery # trace:" +
        // traceid);
        var codepath = $(".virtualMuseum").attr("data-url-gallery");
        codepath = codepath.replace("%7Bid%7D", traceid);

        $(".preloader").show();

        _virtualMuseumUrl = window.location.href;

        window.history.pushState(null, null, codepath);

        $("<div></div>").load(codepath, function(response, status, xhr) {

          if (status == "error") {
            $(".preloader").hide();
            return;
          }
          //When is loaded switch the title
          $(document).prop('title', $("title", this).text());

          $("#virtualMuseumGalleryOverlay").removeClass("active");

          if ($(this).find(".artistGallery").length > 0) {
            $("#virtualMuseumGalleryOverlay").html($(this).find(".artistGallery"));
            $(this).empty();
          } else {
            $(".preloader").hide();
            return;
          }

          $("#virtualMuseumGalleryOverlay").children(".artistGallery").css("opacity", 0);
          $("#virtualMuseumGalleryOverlay").show();
          $(".virtualMuseumFooter").hide();

          $(".preloader").hide();

          $("#virtualMuseumGalleryOverlay").children(".artistGallery").fadeTo(500, 1, function() {
            //$(".virtualMuseumGalleryView").hide();
            //$(".virtualMuseumListView").hide();
            $("#virtualMuseumGalleryOverlay").addClass("active");

            _virtualMuseumDetailViewVisible = true;

            destroyListViewImageLazyLoading();
          });

          Drupal.behaviors.iconCreator($(".artistGallery"));
          Drupal.behaviors.linkButtonCreator($(".artistGallery"));
          Drupal.behaviors.artistGallery.initSlider();

          /*
          setTimeout(function(){
              Drupal.behaviors.artistGallery.updateSlider();
          }, 1000);
          */

          $("#virtualMuseumGalleryOverlay").find(".artistProfileButton").click(function(e) {
            e.preventDefault();
            $("#virtualMuseumGalleryOverlay").removeClass("active");
            $("#virtualMuseumGalleryOverlay").hide();
            $(".virtualMuseumListView").show();
            $("#virtualMuseumProfileOverlay").show();
            var id = $(this).attr("data-artist-id");
            loadArtistProfilePage(id);
          });

          $("#virtualMuseumGalleryOverlay").find(".artistGalleryText .linkButton").click(function(e) {
            if ($(this).hasClass("externalLink")) {
              //load external link...
            } else {
              e.preventDefault();
              $("#virtualMuseumGalleryOverlay").removeClass("active");
              $("#virtualMuseumGalleryOverlay").hide();
              $(".virtualMuseumListView").show();
              $("#virtualMuseumProfileOverlay").show();
              var id = $(this).attr("data-artist-id");
              loadArtistProfilePage(id);
            }
          });

          $("#virtualMuseumGalleryOverlay").find(".artistGalleryClosebutton").click(function(e) {
            e.preventDefault();
            closeDetailView();
          });

          if ($(window).width() > 767) {
            $(document).unbind().scroll(function() {
              $(document).unbind();
              //Drupal.behaviors.functions.consolog("handle scroll!");
              if (window.innerHeight == screen.height) {
                Drupal.behaviors.functions.consolog('Browser is in fullscreen');
              } else if ($("#virtualMuseumGalleryOverlay").hasClass("active")) {
                closeDetailView();
              }

            });
          }
        });
      }

      function loadArtistProfilePage (userid) {
        Drupal.behaviors.functions.consolog("show artist profile # user:" + userid + " ### " + window.history);
        var codepath = $(".virtualMuseum").attr("data-url-artist-profile");
        codepath = codepath.replace("%7Bid%7D", userid);

        _virtualMuseumUrl = window.location.href;
        window.history.pushState(null, null, codepath);

        $(".preloader").show();
        $(".virtualMuseumFooter").hide();

        $("<div></div>").load(codepath, function(response, status, xhr) {
          if (status == "error") {
            $(".preloader").hide();
            $(".virtualMuseumFooter").show();
            return;
          }
          //When is loaded switch the title
          $(document).prop('title', $("title", this).text());
          //save the last artist title in case we go into a trace
          $(".virtualMuseum").data("last-artist-title", $("title", this).text());
          //Drupal.behaviors.functions.consolog("loadArtistProfilePage DONE!");

          $("#virtualMuseumProfileOverlay").removeClass("active");

          if ($(this).find(".artistProfile").length > 0) {
            $("#virtualMuseumProfileOverlay").html($(this).find(".artistProfile"));
            $(this).empty();
          } else {
            $(".preloader").hide();
            $(".virtualMuseumFooter").show();
            return;
          }

          $("#virtualMuseumProfileOverlay").children(".artistProfile").css("opacity", 0);
          $("#virtualMuseumProfileOverlay").show();

          $(".artistProfile").find(".artistProfileBacklink").show();

          $('html, body').scrollTop(0);

          $(".preloader").hide();

          $("#virtualMuseumProfileOverlay").children(".artistProfile").fadeTo(500, 1, function() {
            $(".virtualMuseumGalleryView").hide();
            $(".virtualMuseumListView").hide();
            $("#virtualMuseumProfileOverlay").addClass("active");

            //set click listener for gallery teaser
            $(".artistProfile").find(".artistGalleryTeaserImage").click(function() {
              var traceid = $(this).parent(".artistGalleryTeaser").attr("data-trace-id");
              loadArtistGalleryPage(traceid, userid);
            });
            $(".artistProfile").find(".artistGalleryTeaserLink").click(function() {
              var traceid = $(this).parent(".artistGalleryTeaser").attr("data-trace-id");
              loadArtistGalleryPage(traceid, userid);
            });
            //Drupal.behaviors.fullScreenBehaviorCreator(".artistProfile");

            _virtualMuseumDetailViewVisible = true;

            destroyListViewImageLazyLoading();
          });

          Drupal.behaviors.iconCreator($(".artistProfile"));
          Drupal.behaviors.linkButtonCreator($(".artistProfile"));
          Drupal.behaviors.sliderGalleryCreator($(".artistProfile"));

          Drupal.behaviors.highlightSliderAttachEvents($(document));

          //Setup special video behaviors
          setupVideoOverlayInSmallSlider($(".artistProfile"));
          setupWeChatImgCaller($(".artistProfile"));

          //handle back click
          $("#virtualMuseumProfileOverlay").find(".backlink").click(function(e) {
            e.preventDefault();
            closeDetailView();
          });

          //handle group or artist profile link click
          $("#virtualMuseumProfileOverlay").find(".artistProfileGroupButton").click(function(e) {
            e.preventDefault();
            handleProfileButtonClick($(this).attr("data-group-id"));
          });
          $("#virtualMuseumProfileOverlay").find(".groupProfileArtistButton").click(function(e) {
            e.preventDefault();
            handleProfileButtonClick($(this).attr("data-artist-id"));
          });
        });
      }

      function setupVideoOverlayInSmallSlider (mainContent) {
        $(".videoOverlay", mainContent).click(function() {
          $("#artistProfileVideoModal").data("video-identifier", $(this).data("video-identifier"));
          $("#artistProfileVideoModal").data("video-type", $(this).data("video-type"));
          $("#artistProfileVideoModal").modal("show");
        });
      }

      function setupWeChatImgCaller (mainContent) {
        //Wechat
        $(".weChatModalCaller", mainContent).click(function() {
          $("#artistProfileWeChat").data("wechat-image", $(this).data("wechat-image"));
          $("#artistProfileWeChat").modal("show");
        });
      }


      function handleProfileButtonClick (userid) {
        $("#virtualMuseumGalleryOverlay").removeClass("active");
        $("#virtualMuseumGalleryOverlay").hide();

        if ($(".virtualMuseumListView").hasClass("active")) {
          $(".virtualMuseumListView").show();
        } else if ($(".virtualMuseumGalleryView").hasClass("active")) {
          $(".virtualMuseumGalleryView").show();
        }

        $("#virtualMuseumProfileOverlay").show();
        loadArtistProfilePage(userid);
      }

      function closeDetailView () {

        //Drupal.behaviors.functions.consolog("closeDetailView()");

        window.history.pushState(null, null, _virtualMuseumUrl);


        _virtualMuseumDetailViewVisible = false;

        if ($(".virtualMuseumOverlay.active").length > 1) {
          //Use the last artist title to replace
          $(document).prop('title', $(".virtualMuseum").data("last-artist-title"));
          //hide gallery layer to show profile layer below
          $("#virtualMuseumGalleryOverlay").removeClass("active");

          $("#virtualMuseumGalleryOverlay").children().fadeTo(500, 0, function() {
            $("#virtualMuseumGalleryOverlay").hide();
            $("#virtualMuseumGalleryOverlay").empty();
          });
        } else {
          //if there is nothing else to go back use the original title
          $(document).prop('title', $(".virtualMuseum").data("original-title"));

          $(".virtualMuseumOverlay").children().fadeTo(500, 0, function() {

            //hide layer and return to museum
            $(".virtualMuseumOverlay").empty();
            $(".virtualMuseumOverlay").hide();
            $(".virtualMuseumOverlay").removeClass("active");
            $(".virtualMuseumFooter").show();

          });

          //show virtual museum view (list or gallery)
          if ($(".virtualMuseumOverlay.active").length <= 1) {
            if ($(".virtualMuseumGalleryView").hasClass("active")) {
              $(".virtualMuseumGalleryView").show();
            } else if ($(".virtualMuseumListView").hasClass("active")) {

              //show list view
              $(".virtualMuseumListView").show();

              //reload masonry
              if (($(".virtualMuseum").hasClass("traces") || $(".virtualMuseum").hasClass("collaborations") || $(".virtualMuseum").hasClass("artists")) && _virtualMuseumListViewMasonryEnabled) {
                $(".virtualMuseumListViewContentElementRow").masonry('layout');
                masonryLog('masonry 19');
                // Additional delayed masonry calls to ensure proper layout after returning from detail view
                setTimeout(function() {
                  if (_virtualMuseumListViewMasonryEnabled) {
                    $(".virtualMuseumListViewContentElementRow").masonry('layout');
                    masonryLog('masonry 19a');
                  }
                }, 100);
                setTimeout(function() {
                  if (_virtualMuseumListViewMasonryEnabled) {
                    $(".virtualMuseumListViewContentElementRow").masonry('layout');
                    masonryLog('masonry 19b');
                  }
                }, 500);
                setTimeout(function() {
                  if (_virtualMuseumListViewMasonryEnabled) {
                    $(".virtualMuseumListViewContentElementRow").masonry('layout');
                    masonryLog('masonry 19c');
                  }
                }, 1000);
              }

              //reactivate lazy loading
              activateListViewImageLazyLoading();
            }
          }

          //scroll to active element
          if ($(".virtualMuseumListViewContentElement.active").length > 0) {
            //scroll to selected element
            var sp = $(".virtualMuseumListViewContentElement.active").offset().top - Math.round($(window).height() / 4);
            $('html, body').scrollTop(sp);
            $(".virtualMuseumListViewContentElement").removeClass("active");
          }
        }
      }
    }
  }
})(jQuery);
